module.exports = __webpack_public_path__ + "static/media/filter-new.7f697f34.svg";